// Copyright © 2019-2026 Focal Systems. All rights reserved.

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ProfileDetail } from "@/features/profile/profile-detail";

// The profile is the signed-in user's own page, so it needs no backoffice permission —
// every authenticated user can view and manage their own account.
export const Route = createFileRoute("/_authenticated/profile/")({
  validateSearch: z.object({ t: z.string().optional(), f: z.string().optional() }),
  component: ProfilePage,
});

function ProfilePage() {
  const { t: tab, f } = Route.useSearch();
  return <ProfileDetail tab={tab} initialFilters={f} />;
}
